import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button } from './button';
import { Modal } from './modal';
import { PasswordField } from './password-field';
import { Input } from './input';
import { toast } from './toast';
import { api } from '@/lib/api';

async function extractDetail(err: unknown): Promise<string> {
  try {
    if (err && typeof err === 'object' && 'response' in err) {
      const res = (err as { response: Response }).response;
      const body = await res.clone().json();
      return body?.detail ?? `HTTP ${res.status}`;
    }
  } catch {
    /* fall through */
  }
  return err instanceof Error ? err.message : '网络异常';
}

export function ChangePasswordModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (b: boolean) => void;
}) {
  const [oldPw, setOldPw] = useState('');
  const [newPw, setNewPw] = useState('');

  const mut = useMutation({
    mutationFn: () =>
      api
        .post('auth/change-password', { json: { old_password: oldPw, new_password: newPw } })
        .json(),
    onSuccess: () => {
      toast.success('密码已修改', '请妥善保管');
      setOldPw('');
      setNewPw('');
      onOpenChange(false);
    },
    onError: async (e) => toast.error('修改失败', await extractDetail(e)),
  });

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="修改密码"
      description="新密码 ≥10 位,需含大小写/数字/符号至少 3 类"
      footer={
        <>
          <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
            取消
          </Button>
          <Button
            size="sm"
            disabled={mut.isPending || !oldPw || newPw.length < 10}
            onClick={() => mut.mutate()}
          >
            确认修改
          </Button>
        </>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          mut.mutate();
        }}
        className="space-y-3"
      >
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-neutral-600">原密码</span>
          <Input
            type="password"
            value={oldPw}
            onChange={(e) => setOldPw(e.target.value)}
            autoFocus
            required
          />
        </label>
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-neutral-600">新密码</span>
          <PasswordField value={newPw} onChange={setNewPw} />
        </label>
      </form>
    </Modal>
  );
}
